'use client';
import { APP_ROUTE } from '@src/v3//constants/routes';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import React from 'react';

function Privacy() {
  const { push } = useRouter();
  return (
    <>
      <style jsx>
        {`
        <style type="text/css"> * {margin:0; padding:0; text-indent:0; }
        .p, p { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; margin:0pt; }
        a { color: #1154CC; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: underline; font-size: 11pt; }
        h1 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 11pt; }
        .s1 { color: black; font-family:Arial, sans-serif; font-style: italic; font-weight: normal; text-decoration: none; font-size: 11pt; }
        .s2 { color: #1154CC; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }
        li {display: block; }
        #l1 {padding-left: 0pt;counter-reset: c1 1; }
        #l1> li>*:first-child:before {counter-increment: c1; content: counter(c1, decimal)". "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }
        #l1> li:first-child>*:first-child:before {counter-increment: c1 0;  }
        li {display: block; }
        #l2 {padding-left: 0pt; }
        #l2> li>*:first-child:before {content: "● "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }
        li {display: block; }
        #l3 {padding-left: 0pt; }
        #l3> li>*:first-child:before {content: "● "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }
        #l4 {padding-left: 0pt; }
        #l4> li>*:first-child:before {content: "○ "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }
        #l5 {padding-left: 0pt; }
        #l5> li>*:first-child:before {content: "○ "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }
        #l6 {padding-left: 0pt; }
        #l6> li>*:first-child:before {content: "○ "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }
        li {display: block; }
        #l7 {padding-left: 0pt; }
        #l7> li>*:first-child:before {content: "● "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }
        li {display: block; }
        #l8 {padding-left: 0pt;counter-reset: g1 1; }
        #l8> li>*:first-child:before {counter-increment: g1; content: counter(g1, decimal)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 11pt; }
        #l8> li:first-child>*:first-child:before {counter-increment: g1 0;  }
        #l9 {padding-left: 0pt; }
        #l9> li>*:first-child:before {content: "○ "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }
        #l10 {padding-left: 0pt; }
        #l10> li>*:first-child:before {content: "○ "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }
        #l11 {padding-left: 0pt; }
        #l11> li>*:first-child:before {content: "○ "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }
        #l12 {padding-left: 0pt; }
        #l12> li>*:first-child:before {content: "○ "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }
        #l13 {padding-left: 0pt; }
        #l13> li>*:first-child:before {content: "○ "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }
        #l14 {padding-left: 0pt; }
        #l14> li>*:first-child:before {content: "○ "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }
        li {display: block; }
        #l15 {padding-left: 0pt; }
        #l15> li>*:first-child:before {content: "● "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }
       </style>
        `}
      </style>
      <div className="bg-lightertwo/10">
        <header className="fixed inset-0 bg-white py-7 w-full h-[80px] shrink-0 z-20">
          <nav className="relative h-full flex justify-between items-center max-w-full md:max-w-[1200px] lg:max-w-[1366px] xl:max-w-[1500px] mx-auto px-4 md:px-0">
            <a
              className="flex items-center cursor-pointer"
              onClick={() => {
                push(APP_ROUTE.HOME);
              }}
            >
              <Image
                src="/zeme-colored-logo.png"
                alt="Zeme Logo"
                width={145}
                height={32}
              />
            </a>
          </nav>
        </header>
        <main className="mt-[80px] max-w-full md:max-w-[1200px] lg:max-w-[1366px] xl:max-w-[1500px] mx-auto px-4 md:px-0 pb-10">
          <div className="pt-6 py-4">
            <h2 className="text-2xl font-semibold">Privacy Policy</h2>
          </div>
          <p
            style={{
              paddingTop: '4pt',
              paddingLeft: '5pt',
              textIndent: '0pt',
              textAlign: 'left',
            }}
          >
            Updated October 4, 2023
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            When you use Zeme Inc., (“Zeme”) services, rest assured you are
            trusting us with your data. This Privacy Policy (“Policy”) describes
            the different types of personal data we collect, why we use it, who
            we share it with, and how we protect it. This Policy is not a
            contract and does not create any legal rights or obligations.
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            <a
              href="mailto:privacy@zeme.io"
              style={{
                color: 'black',
                fontFamily: 'Arial, sans-serif',
                fontStyle: 'normal',
                fontWeight: 'normal',
                textDecoration: 'none',
                fontSize: '11pt',
              }}
              target="_blank"
            >
              We carefully evaluate and reevaluate how we use data to ensure
              that we’re using your information to provide value for you. We aim
              to explain everything you need to know about your privacy at Zeme.
              If you have any questions that we haven’t answered here, you can
              always contact us at{' '}
            </a>
            <a href="mailto:privacy@zeme.io" target="_blank">
              privacy@zeme.io
            </a>
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left' }}
          >
            When we use the terms “Zeme ”, “we”, “us”, or “our” in this Policy,
            we are referring to Zeme Inc..
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <h1
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            Our Offerings:{' '}
            <span className="p">
              When we use the terms “offerings” or “services,” we are referring
              to our websites, mobile applications, and other services that link
              to this Policy.
            </span>
          </h1>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left' }}
          >
            This Policy does not cover or address:
          </p>
          <ol id="l1">
            <li data-list-text={1}>
              <p
                style={{
                  paddingTop: '1pt',
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Disclosures or rights we may provide to you in relation to the
                United States Fair Credit Reporting Act (FCRA) or;
              </p>
            </li>
            <li data-list-text={2}>
              <p
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Disclosures or rights we may provide to you in relation to U.S.
                state-specific financial privacy laws;
              </p>
            </li>
            <li data-list-text={3}>
              <p
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  textAlign: 'left',
                }}
              >
                Offerings that we provide solely on behalf of our business
                partners;
              </p>
            </li>
            <li data-list-text={4}>
              <p
                style={{
                  paddingTop: '1pt',
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  textAlign: 'left',
                }}
              >
                The terms and provisions set forth in our Terms of Service;
              </p>
            </li>
            <li data-list-text={5}>
              <p
                style={{
                  paddingTop: '1pt',
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Personal data and privacy practices relating to job applicants,
                employees and other Zeme personnel.
              </p>
            </li>
          </ol>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            For offerings provided on behalf of our customers who are real
            estate professionals (such as brokers, agents, landlords,and
            property managers), please refer to the Policy of the real estate
            professional for information on how they engage us to process your
            personal data.
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <h1
            style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left' }}
          >
            What is Personal Data?
          </h1>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            When we use the term “personal data” in this Policy, we mean
            information that identifies, relates to, describes, is reasonably
            capable of being associated with, or could reasonably be linked,
            directly or indirectly, to an individual or household. This includes
            but is not limited to names, addresses, social security numbers,
            ITINs, EINs, emails, phone numbers and usernames. It does not
            include aggregated or anonymized information that is maintained in a
            form that is not capable of being associated with or reasonably
            linked to an individual.
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <h1
            style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left' }}
          >
            Our Collection and Use of Personal Data
          </h1>
          <p
            style={{
              paddingTop: '4pt',
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            The personal data we collect, the way we collect it, and how we use
            it will depend on how you are interacting with us and the type of
            services you use. Zeme is dedicated to providing the utmost security
            while maintaining the integrity of our services.
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <h1
            style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left' }}
          >
            Information We Collect As You Use Our Services
          </h1>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            className="s1"
            style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left' }}
          >
            Collection of Personal Data
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            As is true of most digital platforms, we and our third-party
            providers collect certain personal data automatically when you visit
            or interact with our websites, mobile apps, and other online
            services. This includes things like your search history, views,
            activity, what you’ve clicked on, other uses of our websites, and
            the amount of time you spend looking at different parts of our
            websites.
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            We, along with our third-party partners, utilize tracking
            technologies to automatically gather information related to
            preferences, internet, network, and device details, which include,
            but are not limited to:
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <ul id="l2">
            <li data-list-text="●">
              <h1
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Information about how you access our services,{' '}
                <span className="p">
                  such as the website from which you came and the website to
                  which you are going when you leave our websites, how
                  frequently you access the services, when and whether you open
                  emails or click the links contained in emails, whether you
                  access the services from multiple devices and other actions
                  you take on the services.
                </span>
              </h1>
            </li>
            <li data-list-text="●">
              <h1
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Information about how you use the services,{' '}
                <span className="p">
                  such as the pages you visit, the links you click, the ads you
                  view and click on, purchase information and your checkout
                  process, your location when you access or interact with our
                  services, and other similar actions.
                </span>
              </h1>
            </li>
            <li data-list-text="●">
              <h1
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Information about the computer, tablet, smartphone or other
                device you use,{' '}
                <span className="p">
                  such as your IP address, browser type, Internet service
                  provider, platform type, device type/model/manufacturer,
                  operating system, date and time stamp, a unique ID that allows
                  us to uniquely identify your browser, mobile device, or your
                  account (including, e.g., a persistent device identifier or an
                  Ad ID), and other such information (referred to herein as “Log
                  Data”).
                </span>
              </h1>
            </li>
            <li data-list-text="●">
              <h1
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Analytics Data,{' '}
                <span className="p">
                  such as information about your activity when you visit our
                  sites or use our apps; this can include clicks, mouse
                  movements, forms you fill out, and similar information. We use
                  this to better understand what features and parts of the
                  website are most useful, and which ones may need to be
                  improved.
                </span>
              </h1>
            </li>
            <li data-list-text="●">
              <h1
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Cookies, pixels, and other tracking:{' '}
                <span className="p">
                  We and our partners use various tools to collect data when you
                  visit our sites and apps, including cookies, pixel tags, and
                  other similar technologies. Cookies are bits of electronic
                  data that can be transferred to your computer or other device
                  to identify your browser. When you use Zeme, we and our
                  partners may use cookies and other tools to gather information
                  about how you view and use our services and content, and to
                  connect your activity with other data we store about you. The
                  use of cookies helps us serve you better by understanding what
                  you’re
                </span>
              </h1>
            </li>
          </ul>
          <p
            style={{
              paddingTop: '4pt',
              paddingLeft: '41pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            interested in, tracking trends, measuring the effectiveness of ads,
            saving your preferences, and storing information you may want to
            retrieve on a regular basis, such as your saves. We also allow
            approved partners to collect data from your browser or device for
            advertising and measurement purposes using their own cookies or
            similar tools; these are categorized as “Advertising Cookies”.
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            This information allows us to improve your customer experience. For
            example, we may use this information to enhance and personalize your
            user experience, to monitor and improve our websites and services,
            and for other internal purposes. We may also use this information
            to: (a) remember information so that you will not have to re-enter
            it during your visit or the next time you visit the platform; (b)
            provide custom, personalized content, and information; (c) identify
            and contact you across multiple devices; (d) provide and monitor the
            effectiveness of our services;
          </p>
          <p
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            (e) perform analytics and detect usage patterns on our services; (f)
            diagnose or fix technology problems; (g) detect or prevent fraud or
            other harmful activities; and (h) enhance our services.
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <h1
            style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left' }}
          >
            Information You Give Us or Create Using Our Services
          </h1>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            className="s1"
            style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left' }}
          >
            Collection of Personal Data
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            When you use our services, websites, or apps, we collect personal
            data from you. We might also collect personal data about you from
            our business partners, payment processors, service providers, and
            other third parties who collect personal data on our behalf. This
            information might include and is not limited to:
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <ul id="l3">
            <li data-list-text="●">
              <h1
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Account Registration and Profile Information:{' '}
                <span className="p">
                  If you register for an account through our services or
                  complete a Zeme profile, we collect account identifiers
                  (including a username and password, as well as internal
                  identifiers we assign to individual accounts to allow our
                  systems to connect account information stored in different
                  databases) and account history and records (including services
                  you’ve used or interacted with, the date and type of account
                  creation, account status, log in activity, transactions, the
                  services we provide, messages received in connection with the
                  services, and your activity on our websites and mobile
                  applications). We use this information to create and
                  administer your account, provide you with the relevant
                  services and information, communicate with you regarding your
                  account and your use of the services, for customer support
                  purposes, and to send you communications by email, push
                  notification, or by text message, in accordance with your
                  preferences.
                </span>
              </h1>
            </li>
            <li data-list-text="●">
              <h1
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Customer Service and Communication History:{' '}
                <span className="p">
                  Including name, address, email, customer service requests,
                  Account Identifiers, Account History and the contents of
                  requests and correspondence with us (including recordings of
                  phone calls, where permitted by law).
                </span>
              </h1>
            </li>
            <li data-list-text="●">
              <h1
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Feedback Information:{' '}
                <span className="p">
                  If you submit a review, feedback or other comments, we collect
                  your contact information (such as first and last name, email
                  address, and phone number) and any feedback and ratings
                  relating to our services and products, including reviews you
                  create of real estate professionals.
                </span>
              </h1>
            </li>
            <li data-list-text="●">
              <h1
                style={{
                  paddingTop: '4pt',
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Inquiries and Communication:{' '}
                <span className="p">
                  If you communicate with us or otherwise submit an inquiry or
                  question (e.g., via webform), we collect your contact
                  information (such as first and last name, email address, and
                  phone number), account identifiers and history (described
                  above), and any other personal data you choose to provide in
                  the content of your message or communication. We use this
                  information to investigate and respond to your inquiries, to
                  facilitate communication with us, to provide you with
                  requested information, to enhance the services we offer, and
                  to manage and grow our business. If you represent a company or
                  agency interested in partnering with us, we will also collect
                  your professional and employment information in order to
                  respond to your inquiries, communicate with you, to manage and
                  grow our organization and to facilitate a business
                  relationship. Our websites and online services provide you the
                  ability to connect with us through an online web form that
                  collects contact information (such as, but not limited to,
                  first and last name, email address, phone number, company
                  name, and title with company), area(s) of interest or concern,
                  and a custom message.
                </span>
              </h1>
            </li>
            <li data-list-text="●">
              <h1
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'justify',
                }}
              >
                Location Data:{' '}
                <span className="p">
                  Including general geographic location reflected in the Log
                  Data we collect or a more precise location when you choose to
                  share it with us through your device or browser settings.
                </span>
              </h1>
            </li>
            <li data-list-text="●">
              <h1
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Newsletters and Email Communication:{' '}
                <span className="p">
                  Many of our websites and online services provide you an
                  opportunity to sign up for our newsletters and email
                  communications by providing your email address. We use your
                  email address to communicate with you about our services and
                  exciting developments at Zeme, which may include marketing
                  communications.
                </span>
              </h1>
            </li>
            <li data-list-text="●">
              <h1
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Payment Information:{' '}
                <span className="p">
                  We and our third-party service providers collect information
                  relating to your transactions with us, including details
                  regarding payments you’ve made through our sites or apps. We
                  use third-party payment tools to process and store payment
                  information like credit card numbers or bank account
                  information. We don’t store this information ourselves.
                </span>
              </h1>
              <p style={{ textIndent: '0pt', textAlign: 'left' }}>
                <br />
              </p>
              <p
                style={{
                  paddingLeft: '5pt',
                  textIndent: '0pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Although we often collect the personal data described above
                directly from you, we may also collect certain information
                through our business partners, service providers, and other
                third parties that collect it on our behalf, such as
                communications providers, data brokers, payment processors,
                payment system providers, and information technology providers.
              </p>
              <p style={{ textIndent: '0pt', textAlign: 'left' }}>
                <br />
              </p>
              <p
                style={{
                  paddingLeft: '5pt',
                  textIndent: '0pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Please note that we link the personal data we collect in
                connection with our services with the other personal data that
                we collect and may use it for the purposes we describe in more
                detail in the other sections of this Policy.
              </p>
              <p style={{ textIndent: '0pt', textAlign: 'left' }}>
                <br />
              </p>
              <h1
                style={{
                  paddingLeft: '5pt',
                  textIndent: '0pt',
                  textAlign: 'left',
                }}
              >
                Other Collection of Personal Data
              </h1>
              <p style={{ textIndent: '0pt', textAlign: 'left' }}>
                <br />
              </p>
              <p
                style={{
                  paddingLeft: '5pt',
                  textIndent: '0pt',
                  textAlign: 'left',
                }}
              >
                In addition to the personal data collected above, we may also
                collect personal data as follows:
              </p>
              <p style={{ textIndent: '0pt', textAlign: 'left' }}>
                <br />
              </p>
            </li>
            <li data-list-text="●">
              <h1
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Business Partners:{' '}
                <span className="p">
                  Our business partners collect personal data in connection with
                  their services and often share some or all of this information
                  with us. For example, we receive
                </span>
              </h1>
              <p
                style={{
                  paddingTop: '4pt',
                  paddingLeft: '41pt',
                  textIndent: '0pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                information about transactions you complete with partners with
                whom we’ve connected you through our services.
              </p>
            </li>
            <li data-list-text="●">
              <h1
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Business Representatives:{' '}
                <span className="p">
                  We collect professional personal data about representatives of
                  third-party businesses, including representatives of our
                  customers and business partners, in connection with our
                  services and the operation of our business, which may include:
                </span>
              </h1>
              <ul id="l4">
                <li data-list-text="○">
                  <p
                    className="s1"
                    style={{
                      paddingLeft: '77pt',
                      textIndent: '-18pt',
                      lineHeight: '114%',
                      textAlign: 'left',
                    }}
                  >
                    Contact Information:{' '}
                    <span className="p">
                      Including full name, email address, mailing address, and
                      telephone number.
                    </span>
                  </p>
                </li>
                <li data-list-text="○">
                  <p
                    className="s1"
                    style={{
                      paddingLeft: '77pt',
                      textIndent: '-18pt',
                      lineHeight: '114%',
                      textAlign: 'left',
                    }}
                  >
                    Professional Information:{' '}
                    <span className="p">
                      Including job title, job function, company name and
                      characteristics, professional background, and nature of
                      the relationship with us.
                    </span>
                  </p>
                </li>
                <li data-list-text="○">
                  <p
                    className="s1"
                    style={{
                      paddingLeft: '77pt',
                      textIndent: '-18pt',
                      lineHeight: '114%',
                      textAlign: 'left',
                    }}
                  >
                    Tax and Payment Information:{' '}
                    <span className="p">
                      Including a personal tax identification number, bank
                      account information, and payment information where you are
                      a representative of a sole proprietor or similar legal
                      structure that uses personal tax and account information
                      in lieu of separate business information.
                    </span>
                  </p>
                </li>
                <li data-list-text="○">
                  <p
                    className="s1"
                    style={{
                      paddingLeft: '77pt',
                      textIndent: '-18pt',
                      lineHeight: '114%',
                      textAlign: 'left',
                    }}
                  >
                    Inquiry Information:{' '}
                    <span className="p">
                      Including the contents of emails, texts, and other
                      communications and, where permitted by law, recordings of
                      calls with us.
                    </span>
                  </p>
                </li>
                <li data-list-text="○">
                  <p
                    className="s1"
                    style={{
                      paddingLeft: '77pt',
                      textIndent: '-18pt',
                      lineHeight: '114%',
                      textAlign: 'left',
                    }}
                  >
                    Feedback Information
                    <span className="p">
                      : Including information provided in response to surveys we
                      may conduct with customers or business partners, or
                      unsolicited feedback received regarding our services and
                      business.
                    </span>
                  </p>
                </li>
              </ul>
            </li>
            <li data-list-text="●">
              <h1
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Office and Event Visitors
                <span className="p">
                  : We collect personal data about visitors to our physical
                  offices and events, which may include:
                </span>
              </h1>
              <ul id="l5">
                <li data-list-text="○">
                  <p
                    className="s1"
                    style={{
                      paddingLeft: '77pt',
                      textIndent: '-18pt',
                      lineHeight: '114%',
                      textAlign: 'left',
                    }}
                  >
                    Contact Information:{' '}
                    <span className="p">
                      Including full name, email address, mailing address, and
                      telephone number.
                    </span>
                  </p>
                </li>
                <li data-list-text="○">
                  <p
                    className="s1"
                    style={{
                      paddingLeft: '77pt',
                      textIndent: '-18pt',
                      lineHeight: '114%',
                      textAlign: 'left',
                    }}
                  >
                    Professional Information:{' '}
                    <span className="p">
                      Including job title, job function, company name,
                      professional background, and nature of the relationship
                      with us.
                    </span>
                  </p>
                </li>
                <li data-list-text="○">
                  <p
                    className="s1"
                    style={{
                      paddingLeft: '77pt',
                      textIndent: '-18pt',
                      lineHeight: '114%',
                      textAlign: 'left',
                    }}
                  >
                    Visit Information:{' '}
                    <span className="p">
                      Including the purpose of the visit and any restrictions or
                      preferences while on premise (such as dietary
                      restrictions).
                    </span>
                  </p>
                </li>
                <li data-list-text="○">
                  <p
                    className="s1"
                    style={{
                      paddingLeft: '77pt',
                      textIndent: '-18pt',
                      lineHeight: '114%',
                      textAlign: 'left',
                    }}
                  >
                    Security Information:{' '}
                    <span className="p">
                      Including a copy of a government ID (such as a driver’s
                      license) and a record of the visitor’s access to our
                      office or event, any use by the visitor of our computer
                      systems, and images or video recordings of the visitor
                      while on premises (where permitted by law).
                    </span>
                  </p>
                </li>
              </ul>
            </li>
            <li data-list-text="●">
              <h1
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Service Providers
                <span className="p">
                  : Our service providers, such as payment processors and
                  marketing providers, collect personal data and often share
                  some or all of this information with us. For example, we
                  receive personal data from payment processors to confirm that
                  an individual’s payment for the services was accepted. We use
                  this information to comply with our legal obligations, to
                  monitor activity to identify and provide you with promotions
                  and offers, and to prevent fraud, protect our rights and the
                  rights of others, to inform our marketing and advertising
                  activities, and to help provide our services.
                </span>
              </h1>
            </li>
            <li data-list-text="●">
              <h1
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Information Providers
                <span className="p">
                  : We may from time to time obtain information from third-party
                  information providers to correct or supplement personal data
                  we collect. For example, we may obtain updated contact
                  information from third-party information providers to
                  reconnect with you.
                </span>
              </h1>
            </li>
            <li data-list-text="●">
              <h1
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Publicly Available Information
                <span className="p">
                  : We may collect personal data from publicly available
                  sources, such as information you publicly post or tag us in on
                  social media sites or
                </span>
              </h1>
              <p
                style={{
                  paddingTop: '4pt',
                  paddingLeft: '41pt',
                  textIndent: '0pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                elsewhere online, and information contained in public records
                databases, such as government records or public review websites,
                to supplement the personal data identified above. We will use
                this information to conduct market research, verify your
                identity, prevent fraud, and improve our services.
              </p>
              <p style={{ textIndent: '0pt', textAlign: 'left' }}>
                <br />
              </p>
              <h1
                style={{
                  paddingLeft: '5pt',
                  textIndent: '0pt',
                  textAlign: 'left',
                }}
              >
                Other Uses of Personal Data
              </h1>
              <p style={{ textIndent: '0pt', textAlign: 'left' }}>
                <br />
              </p>
              <p
                style={{
                  paddingLeft: '5pt',
                  textIndent: '0pt',
                  textAlign: 'left',
                }}
              >
                In addition to the uses identified above, we use the personal
                data we collect to:
              </p>
              <p style={{ textIndent: '0pt', textAlign: 'left' }}>
                <br />
              </p>
            </li>
            <li data-list-text="●">
              <p
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Facilitate our day-to-day business operations, such as helping
                you find your next home, or connect with a real estate agent,
                lender, landlord, or other real estate professional;
              </p>
            </li>
            <li data-list-text="●">
              <p
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Create and maintain the services, develop new products and
                services, and improve existing products and services;
              </p>
            </li>
            <li data-list-text="●">
              <p
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Aggregate information we receive from you and third parties to
                help understand individual needs, customize our services and
                offerings, and provide everyone better service;
              </p>
            </li>
            <li data-list-text="●">
              <p
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Conduct research and analytics designed to understand our
                customer base and improve and grow our business, products,
                services, and customer experience;
              </p>
            </li>
            <li data-list-text="●">
              <p
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  textAlign: 'left',
                }}
              >
                Communicate with you to provide technical or administrative
                support;
              </p>
            </li>
            <li data-list-text="●">
              <p
                style={{
                  paddingTop: '1pt',
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Prevent, investigate, and defend against fraud or unlawful or
                criminal activity, access to, or use of personal data and our
                data system services;
              </p>
            </li>
            <li data-list-text="●">
              <p
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Enforce, investigate, and resolve disputes and security issues
                and to enforce our Terms of Service and any other contracts;
              </p>
            </li>
            <li data-list-text="●">
              <p
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  textAlign: 'left',
                }}
              >
                Comply with legal obligations and other governmental demands;
              </p>
            </li>
            <li data-list-text="●">
              <p
                style={{
                  paddingTop: '1pt',
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Understand your preferences and interests to better serve you on
                your home-finding journey;
              </p>
            </li>
            <li data-list-text="●">
              <p
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Personalize your individual experience, including providing
                educational resources and pointing you to homes you might be
                interested in or offerings of ours that might help you find your
                next home; and
              </p>
            </li>
            <li data-list-text="●">
              <p
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  textAlign: 'left',
                }}
              >
                For any other lawful, legitimate business purpose.
              </p>
              <p style={{ textIndent: '0pt', textAlign: 'left' }}>
                <br />
              </p>
              <h1
                style={{
                  paddingLeft: '5pt',
                  textIndent: '0pt',
                  textAlign: 'left',
                }}
              >
                Our Disclosure of Personal Data
              </h1>
              <p
                style={{
                  paddingLeft: '5pt',
                  textIndent: '0pt',
                  lineHeight: '29pt',
                  textAlign: 'left',
                }}
              >
                We may disclose your personal data in the instances described
                below. We disclose your personal data in the following ways:
              </p>
            </li>
            <li data-list-text="●">
              <h1
                style={{
                  paddingTop: '2pt',
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Business Partners
                <span className="p">
                  : We may share your personal data with our business partners
                  in order to provide you with our products and services.
                </span>
              </h1>
            </li>
            <li data-list-text="●">
              <h1
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Marketing Partners
                <span className="p">
                  : We coordinate and share your personal data with our
                  marketing partners, including advertising networks, social
                  networks, and marketing communication providers, in order to
                  communicate with you about our products and services and
                  market our products and services to you. We may also share
                  aggregated demographic information with third parties
                  interested in advertising on our online services to assist
                </span>
              </h1>
              <p
                style={{
                  paddingTop: '4pt',
                  paddingLeft: '41pt',
                  textIndent: '0pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                them in understanding the audience they would be reaching, but
                this information is not designed to identify any specific
                individual.
              </p>
            </li>
            <li data-list-text="●">
              <h1
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Service Providers
                <span className="p">
                  : We share information with third party vendors and service
                  providers that perform services for or on our behalf, which
                  may include identifying and serving targeted advertisements,
                  providing mailing or email services, tax and accounting
                  services, customer service, product fulfillment, payments
                  processing, photo sharing, data processing and enhancement
                  services, fraud prevention, web hosting, analytic services, or
                  other online functionality, subject to appropriate contractual
                  terms protecting the confidentiality and use of such data.
                </span>
              </h1>
            </li>
            <li data-list-text="●">
              <h1
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Business Transaction or Reorganization
                <span className="p">
                  : We may take part in or be involved with a corporate business
                  transaction, such as a merger, acquisition, joint venture, or
                  financing or sale of company assets. We may disclose your
                  personal data to a third party during negotiation of, in
                  connection with, or as an asset in such a corporate business
                  transaction. Your personal data may also be disclosed in the
                  event of insolvency, bankruptcy, or receivership.
                </span>
              </h1>
            </li>
            <li data-list-text="●">
              <h1
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Legal Obligations and Rights
                <span className="p">
                  : We may disclose your personal data to third parties, such as
                  legal advisors and law enforcement:
                </span>
              </h1>
              <ul id="l6">
                <li data-list-text="○">
                  <p
                    style={{
                      paddingLeft: '77pt',
                      textIndent: '-18pt',
                      textAlign: 'left',
                    }}
                  >
                    In connection with the establishment, exercise, or defense
                    of legal claims;
                  </p>
                </li>
                <li data-list-text="○">
                  <p
                    style={{
                      paddingTop: '1pt',
                      paddingLeft: '77pt',
                      textIndent: '-18pt',
                      lineHeight: '114%',
                      textAlign: 'left',
                    }}
                  >
                    To comply with laws and regulations or to respond to lawful
                    requests and legal process;
                  </p>
                </li>
                <li data-list-text="○">
                  <p
                    style={{
                      paddingLeft: '77pt',
                      textIndent: '-18pt',
                      lineHeight: '114%',
                      textAlign: 'left',
                    }}
                  >
                    To protect our rights and property and the rights and
                    property of our agents, customers, and others, including to
                    enforce our agreements, policies, and terms of use;
                  </p>
                </li>
                <li data-list-text="○">
                  <p
                    style={{
                      paddingLeft: '77pt',
                      textIndent: '-18pt',
                      textAlign: 'left',
                    }}
                  >
                    To detect, suppress, investigate or prevent fraud;
                  </p>
                </li>
                <li data-list-text="○">
                  <p
                    style={{
                      paddingTop: '1pt',
                      paddingLeft: '77pt',
                      textIndent: '-18pt',
                      textAlign: 'left',
                    }}
                  >
                    To reduce credit risk and collect debts owed to us;
                  </p>
                </li>
                <li data-list-text="○">
                  <p
                    style={{
                      paddingTop: '1pt',
                      paddingLeft: '77pt',
                      textIndent: '-18pt',
                      textAlign: 'left',
                    }}
                  >
                    To protect the health and safety of us, our customers, or
                    any person; or
                  </p>
                </li>
                <li data-list-text="○">
                  <p
                    style={{
                      paddingTop: '1pt',
                      paddingLeft: '77pt',
                      textIndent: '-18pt',
                      textAlign: 'left',
                    }}
                  >
                    As otherwise required by applicable law.
                  </p>
                </li>
              </ul>
            </li>
            <li data-list-text="●">
              <h1
                style={{
                  paddingTop: '1pt',
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Otherwise with Consent or At Your Direction:{' '}
                <span className="p">
                  We may disclose your personal data to certain other third
                  parties or publicly with your consent or direction. If you
                  post a comment or review our website or a comment on our
                  social media sites, the information you provide may be
                  displayed publicly online for others to view.
                </span>
              </h1>
            </li>
          </ul>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <h1
            style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left' }}
          >
            Choices About Your Data
          </h1>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <h1
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            Profile Access
            <span className="p">
              . You may access and update your profile information, such as your
              username, address, or billing information.
            </span>
          </h1>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <h1
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            Location and Device Permissions
            <span className="p">
              . You may control location tracking by adjusting your location
              services options on the “Settings” app on your mobile device. We
              may continue to approximate your location based on your IP address
              when you access the services through a computer or device. If you
              would like to update your device content access permissions, such
              as permissions to access your camera, you can do so in the
              “Settings” app on your mobile device.
            </span>
          </h1>
          <h1
            style={{
              paddingTop: '4pt',
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            Promotional Messages
            <span className="p">
              . You can stop receiving promotional email communications from us
              by following the “unsubscribe” instructions provided in such
              communications. We make every effort to promptly process all
              unsubscribe requests. You may still receive service-related
              communications, including account verification, transactional
              communications, changes/updates to features of the services, and
              technical and security notices.
            </span>
          </h1>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <h1
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            Third-Party Tracking and Interest-Based Advertising.{' '}
            <span className="p">
              We may participate in interest-based advertising and use third
              party advertising companies to serve you targeted advertisements
              based on your browsing history. We may permit third party online
              advertising networks, social media companies, and other
              third-party services to collect information about your use of our
              websites, including our mobile apps, over time so that they may
              play or display ads on our services, on other websites, apps, or
              services you may use, and on other devices you may use. Typically,
              though not always, the information used for interest-based
              advertising is collected through tracking technologies, such as
              cookies, flash objects, web beacons, embedded scripts, mobile
              SDKs, location-identifying technologies, and similar technology
              (collectively, “tracking technologies”), which recognize the
              device you are using and collect information, including
              clickstream information, browser type, time and date you visited
              the site, device ID or AdID, geolocation, and other information.
              We may share a common account identifier (such as an
            </span>
          </h1>
          <p
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            e-mail address or user ID) or hashed data with our third-party
            advertising partners to help identify you across devices. We and our
            third-party partners may use this information to make the
            advertisements you see online more relevant to your interests, as
            well as to provide advertising-related services such as reporting,
            attribution, analytics, and market research.
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            We, or our third-party partners, may link your various devices so
            that content you see on one device can result in relevant
            advertising on another device. We may share a common account
            identifier (such as a hashed email address or user ID) or work with
            third-party partners who use tracking technologies or statistical
            modeling tools to determine if two or more devices are linked to a
            single user or household. We, and our partners, can use this
            cross-device linkage to serve interest-based advertising and other
            personalized content to you across your devices (including to
            improve your user experience), to perform analytics, and to measure
            the performance of our advertising campaigns.
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <h1
            style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left' }}
          >
            Your Choices
          </h1>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            <a
              href="http://www.networkadvertising.org/choices"
              style={{
                color: 'black',
                fontFamily: 'Arial, sans-serif',
                fontStyle: 'normal',
                fontWeight: 'normal',
                textDecoration: 'none',
                fontSize: '11pt',
              }}
              target="_blank"
            >
              As noted above, depending on your browser or mobile device, you
              may be able to set your browser to delete or notify you of cookies
              and other tracking technology by actively managing the settings on
              your browser or mobile device. You may be able to limit
              interest-based advertising through the settings on your mobile
              device by selecting “limit ad tracking” (iOS) or “opt-out of
              interest based ads” (Android). Please note that opt-outs are
              browser specific, so opting out on one browser will not affect a
              second browser, or device. Moreover, if you buy a new device, use
              a different browser, or clear all your cookies, you will have to
              opt out all over again. To learn more about interest-based
              advertising and how you may be able to opt-out of some of this
              advertising, you may wish to visit the Network Advertising
              Initiative’s online resources, at{' '}
            </a>
            <span
              style={{
                color: '#1154CC',
                fontFamily: 'Arial, sans-serif',
                fontStyle: 'normal',
                fontWeight: 'normal',
                textDecoration: 'underline',
                fontSize: '11pt',
              }}
            >
              http://www.networkadvertising.org/choices
            </span>
            , and/or the DAA’s resources at
          </p>
          <p
            style={{
              paddingTop: '4pt',
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            <span
              style={{
                color: '#1154CC',
                fontFamily: 'Arial, sans-serif',
                fontStyle: 'normal',
                fontWeight: 'normal',
                textDecoration: 'underline',
                fontSize: '11pt',
              }}
            >
              www.aboutads.info/choices
            </span>
            . You may also be able to opt-out of some – but not all
            –interest-based ads served by mobile ad networks by visiting
          </p>
          <p
            className="s2"
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            <span
              style={{
                color: '#1154CC',
                fontFamily: 'Arial, sans-serif',
                fontStyle: 'normal',
                fontWeight: 'normal',
                textDecoration: 'underline',
                fontSize: '11pt',
              }}
            >
              http://youradchoices.com/appchoices
            </span>{' '}
            <span style={{ color: '#000' }}>
              and downloading the mobile AppChoices app. Note that some of these
              opt-outs may not be effective unless your browser is set to accept
              cookies. If you delete cookies, change your browser settings,
              switch browsers or computers, or use another operating system, you
              may need to opt-out again.
            </span>
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <h1
            style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left' }}
          >
            Minor’s Personal Data
          </h1>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            Our websites and online services are not directed to, and we do not
            intend to or knowingly collect or solicit personal data from minors
            under the age of 18. If you are under the age of 18, please do not
            use our websites or online services or otherwise provide us with any
            personal data either directly or by other means. If a minor under
            the age of 18 has provided personal data to us, we encourage the
            minor’s parent or guardian to contact us as described below to
            request that we remove the personal data from our systems. If we
            learn that any personal data we collect has been provided by a minor
            under the age of 18, we will promptly delete that personal data.
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <h1
            style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left' }}
          >
            Third-Party Websites
          </h1>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            Our websites and online services may include links to or redirect
            you to third-party websites, plug-ins and applications, including
            social media services where you may connect with us. Third-party
            websites may also reference or link to our websites and online
            services. Except where we post, link to, or expressly adopt or refer
            to this Policy, this Policy does not apply to, and we are not
            responsible for, any personal data practices of third-party websites
            and online services or the practices of other third parties. To
            learn about the personal data practices of these third parties,
            please visit their respective policy or policies.
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <h1
            style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left' }}
          >
            Updates to this Policy
          </h1>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            We will update this Policy from time to time. When we make changes
            to this Policy, we will change the “Last Updated” date at the
            beginning of this Policy. If we make material changes to this
            Policy, we will notify you. All changes shall be effective from the
            date of publication unless otherwise provided in the notification.
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <h1
            style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left' }}
          >
            Contact Us
          </h1>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            <a
              href="mailto:privacy@zeme.io"
              style={{
                color: 'black',
                fontFamily: 'Arial, sans-serif',
                fontStyle: 'normal',
                fontWeight: 'normal',
                textDecoration: 'none',
                fontSize: '11pt',
              }}
              target="_blank"
            >
              If you have any questions or requests in connection with this
              Policy or other privacy-related matters, please send an email to{' '}
            </a>
            <a href="mailto:privacy@zeme.io" target="_blank">
              privacy@zeme.io
            </a>
          </p>
          <p
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            Alternatively, inquiries may be addressed to: Zeme Inc. 240 W 40th
            Street, 2nd Floor, New York, NY 10018 Attention: Privacy
          </p>
          <h1
            style={{
              paddingTop: '4pt',
              paddingLeft: '5pt',
              textIndent: '0pt',
              textAlign: 'left',
            }}
          >
            Additional U.S. State Privacy Disclosures
          </h1>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            These Additional U.S. State Privacy Disclosures supplement the above
            information by providing additional information about our personal
            data processing practices relating to individual residents of the
            States of California, Colorado, Connecticut, Utah, and Virginia.
            Unless otherwise expressly stated, all terms defined in our Policy
            retain the same meaning in these Disclosures.
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <h1
            style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left' }}
          >
            Additional Personal Data Disclosures
          </h1>
          <p
            className="s1"
            style={{
              paddingTop: '1pt',
              paddingLeft: '5pt',
              textIndent: '0pt',
              textAlign: 'left',
            }}
          >
            Sensitive Information
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            The following personal data elements we collect may be classified as
            “sensitive” under certain privacy laws (“sensitive information”):
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <ul id="l7">
            <li data-list-text="●">
              <p
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  textAlign: 'left',
                }}
              >
                Social Security number, driver’s license number, and passport
                number;
              </p>
            </li>
            <li data-list-text="●">
              <p
                style={{
                  paddingTop: '1pt',
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  lineHeight: '114%',
                  textAlign: 'left',
                }}
              >
                Credit/debit card number plus expiration date and security code
                (CVV), and financial account number and routing number;
              </p>
            </li>
            <li data-list-text="●">
              <p
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  textAlign: 'left',
                }}
              >
                Username and password; and
              </p>
            </li>
            <li data-list-text="●">
              <p
                style={{
                  paddingTop: '1pt',
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  textAlign: 'left',
                }}
              >
                Precise geolocation data.
              </p>
            </li>
          </ul>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            We use this sensitive information for the purposes set forth in the
            “Our Collection and Use of Personal Data” section of our Policy, to
            provide you full use of our services, to comply with legal and
            regulatory requirements, to protect the life or physical safety of
            you or others, or as otherwise permissible for our internal business
            purposes consistent with applicable laws.
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            We do not sell your sensitive information, and we do not process or
            otherwise share sensitive information for the purpose of targeted
            advertising.
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <h1
            style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left' }}
          >
            Anonymized Information
          </h1>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            We may at times receive or process personal data to create
            anonymized data that can no longer reasonably be used to infer
            information about, or otherwise be linked to, a particular
            individual or household. Where we maintain anonymized data, we will
            maintain and use the data in anonymized form and not attempt to
            re-identify the data except as required or permitted by law.
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <h1
            style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left' }}
          >
            Your Privacy Choices
          </h1>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            Depending on your state of residency and subject to certain legal
            limitations and exceptions, you may be able to exercise some or all
            of the following rights:
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <ol id="l8">
            <li data-list-text="1)">
              <h1
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  textAlign: 'justify',
                }}
              >
                The Right to Know
              </h1>
              <ul id="l9">
                <li data-list-text="○">
                  <p
                    style={{
                      paddingTop: '1pt',
                      paddingLeft: '77pt',
                      textIndent: '-18pt',
                      lineHeight: '114%',
                      textAlign: 'justify',
                    }}
                  >
                    The right to confirm whether we are processing your personal
                    data and, under some state laws, to obtain certain
                    personalized details about the personal data we have
                    collected about you, including:
                  </p>
                </li>
                <li data-list-text="○">
                  <p
                    style={{
                      paddingTop: '4pt',
                      paddingLeft: '77pt',
                      textIndent: '-18pt',
                      textAlign: 'left',
                    }}
                  >
                    The categories of personal data collected;
                  </p>
                </li>
                <li data-list-text="○">
                  <p
                    style={{
                      paddingTop: '1pt',
                      paddingLeft: '77pt',
                      textIndent: '-18pt',
                      textAlign: 'left',
                    }}
                  >
                    The categories of sources of the personal data;
                  </p>
                </li>
                <li data-list-text="○">
                  <p
                    style={{
                      paddingTop: '1pt',
                      paddingLeft: '77pt',
                      textIndent: '-18pt',
                      textAlign: 'left',
                    }}
                  >
                    The purposes for which the personal data were collected;
                  </p>
                </li>
                <li data-list-text="○">
                  <p
                    style={{
                      paddingTop: '1pt',
                      paddingLeft: '77pt',
                      textIndent: '-18pt',
                      lineHeight: '114%',
                      textAlign: 'left',
                    }}
                  >
                    The categories of personal data disclosed to third parties
                    (if any), and the categories of recipients to whom the
                    personal data were disclosed;
                  </p>
                </li>
                <li data-list-text="○">
                  <p
                    style={{
                      paddingLeft: '77pt',
                      textIndent: '-18pt',
                      lineHeight: '114%',
                      textAlign: 'left',
                    }}
                  >
                    The categories of personal data shared for cross-context
                    behavioral advertising purposes (if any), and the categories
                    of recipients to whom the personal data were disclosed for
                    those purposes; and
                  </p>
                </li>
                <li data-list-text="○">
                  <p
                    style={{
                      paddingLeft: '77pt',
                      textIndent: '-18pt',
                      lineHeight: '114%',
                      textAlign: 'left',
                    }}
                  >
                    The categories of personal data sold (if any), and the
                    categories of third parties to whom the personal data were
                    sold data and, under some state laws, to obtain certain
                    personalized details about the personal data we have
                    collected about you, including: The categories of personal
                    data collected; The categories of sources of the personal
                    data; The purposes for which the personal data were
                    collected; The categories of personal data disclosed to
                    third parties (if any), and the categories of recipients to
                    whom the personal data were disclosed; The categories of
                    personal data shared for cross-context behavioral
                    advertising purposes (if any), and the categories of
                    recipients to whom the personal data were disclosed for
                    those purposes; and The categories of personal data sold (if
                    any), and the categories of third parties to whom the
                    personal data were sold.
                  </p>
                </li>
              </ul>
            </li>
            <li data-list-text="2)">
              <h1
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  textAlign: 'left',
                }}
              >
                The Right to Access &amp; Portability
              </h1>
              <ul id="l10">
                <li data-list-text="○">
                  <p
                    style={{
                      paddingTop: '1pt',
                      paddingLeft: '77pt',
                      textIndent: '-18pt',
                      lineHeight: '114%',
                      textAlign: 'left',
                    }}
                  >
                    The right to obtain access to the personal data we have
                    collected about you and, where required by law, the right to
                    obtain a copy of the personal data in a portable and, to the
                    extent technically feasible, readily usable format that
                    allows you to transmit the data to another entity without
                    hindrance.
                  </p>
                </li>
              </ul>
            </li>
            <li data-list-text="3)">
              <h1
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  textAlign: 'left',
                }}
              >
                The Right to Correction
              </h1>
              <ul id="l11">
                <li data-list-text="○">
                  <p
                    style={{
                      paddingTop: '1pt',
                      paddingLeft: '77pt',
                      textIndent: '-18pt',
                      lineHeight: '114%',
                      textAlign: 'left',
                    }}
                  >
                    The right to correct inaccuracies in your personal data,
                    taking into account the nature of the personal data and the
                    purposes of the processing of the personal data.
                  </p>
                </li>
              </ul>
            </li>
            <li data-list-text="4)">
              <h1
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  textAlign: 'left',
                }}
              >
                The Right to Deletion
              </h1>
              <ul id="l12">
                <li data-list-text="○">
                  <p
                    style={{
                      paddingTop: '1pt',
                      paddingLeft: '77pt',
                      textIndent: '-18pt',
                      textAlign: 'left',
                    }}
                  >
                    The right to have us delete the personal data we maintain
                    about you.
                  </p>
                </li>
              </ul>
            </li>
            <li data-list-text="5)">
              <h1
                style={{
                  paddingTop: '1pt',
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  textAlign: 'left',
                }}
              >
                The Right to Opt-Out of Sales or Sharing of Personal Data
              </h1>
              <ul id="l13">
                <li data-list-text="○">
                  <p
                    style={{
                      paddingTop: '1pt',
                      paddingLeft: '77pt',
                      textIndent: '-18pt',
                      lineHeight: '114%',
                      textAlign: 'left',
                    }}
                  >
                    The right to direct us not to “sell” your personal data to
                    third parties for monetary or other valuable consideration,
                    or “share” your personal data to third parties for
                    cross-context behavioral advertising purposes and targeted
                    advertising purposes.
                  </p>
                </li>
              </ul>
            </li>
            <li data-list-text="6)">
              <h1
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  textAlign: 'left',
                }}
              >
                “Shine the Light”
              </h1>
              <ul id="l14">
                <li data-list-text="○">
                  <p
                    style={{
                      paddingTop: '1pt',
                      paddingLeft: '77pt',
                      textIndent: '-18pt',
                      lineHeight: '114%',
                      textAlign: 'left',
                    }}
                  >
                    California residents that have an established business
                    relationship with us have rights to know how their personal
                    data is disclosed to third parties for their direct
                    marketing purposes under California’s “Shine the Light” law,
                    or the right to opt out of such practices (Civ. Code
                    §1798.83).
                  </p>
                </li>
              </ul>
            </li>
          </ol>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            Depending on your state of residence, you may also have the right to
            not receive retaliatory or discriminatory treatment in connection
            with a request to exercise the above rights. However, the exercise
            of the rights described above may result in a different price, rate,
            or quality level of
          </p>
          <p
            style={{
              paddingTop: '4pt',
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            product or service where that difference is reasonably related to
            the impact the right has on our relationship or is otherwise
            permitted by law.
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <h1
            style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left' }}
          >
            Submitting Privacy Rights Requests
          </h1>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left' }}
          >
            To submit a request to exercise one of the privacy rights identified
            above, please:
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <ul id="l15">
            <li data-list-text="●">
              <p
                style={{
                  paddingLeft: '41pt',
                  textIndent: '-18pt',
                  textAlign: 'left',
                }}
              >
                <a
                  href="mailto:privacy@zeme.io"
                  style={{
                    color: 'black',
                    fontFamily: 'Arial, sans-serif',
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    textDecoration: 'none',
                    fontSize: '11pt',
                  }}
                  target="_blank"
                >
                  Email us at{' '}
                </a>
                <a href="mailto:privacy@zeme.io" target="_blank">
                  privacy@zeme.io
                </a>
              </p>
            </li>
          </ul>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            We may need to verify your identity before processing your request.
            In order to submit a request, you’ll need to log in to your account
            with us so we can verify your identity. If you can’t log in or don’t
            have an account, we may not be able to link you to any personal data
            of yours on our systems, but we’ll do our best. In certain
            circumstances, we may decline a request to exercise the rights
            described above, particularly where we are unable to verify your
            identity or locate your information in our systems. We will use
            personal data provided in connection with a Rights Request only to
            review and comply with the request.
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            className="s1"
            style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left' }}
          >
            To Exercise Your Right to Opt-Out of Personal Data Sales or Sharing
            for Targeted Advertising
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            Unless you have exercised your Right to Opt-Out, we may disclose
            your personal data to third parties who may use such information for
            their own purposes in accordance with their own privacy policies.
            Under some state laws, disclosing personal data for online
            advertising like this may be considered a “sale of personal data” or
            “sharing for targeted advertising.”
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            Zeme allows certain companies to place tracking technologies like
            cookies and pixels on our sites, which allow those companies to
            receive information about your activity on Zeme that is associated
            with your browser or device. The companies may use that data to
            serve you more relevant ads on our sites or others. Except for this
            kind of selling or sharing, Zeme doesn’t otherwise sell any of your
            personal data. You always have control over whether these
            technologies work on your devices. At any time, you can use our
            cookie preference tools to manage what kinds of cookies and other
            tracking technologies you’re comfortable with. You can also disable
            cookies altogether by adjusting the settings on your browser.
            However, if you choose to disable some or all cookies, many parts of
            our services may no longer work. For more information, see the
            “Third-Party Tracking and Interest-Based Advertising” section in the
            Policy.
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            You do not need to create an account with us to exercise your Right
            to Opt-Out. However, we may ask you to provide additional personal
            data so that we can properly identify you to track compliance with
            your opt-out request. We will only use personal data provided in an
            opt-out request to review and comply with the request. If you choose
            not to provide this data, we may be able to process your request
            only to the extent we are able to identify you in our data systems.
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            className="s2"
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            <a
              href="mailto:privacy@zeme.io"
              style={{
                color: 'black',
                fontFamily: 'Arial, sans-serif',
                fontStyle: 'normal',
                fontWeight: 'normal',
                textDecoration: 'none',
                fontSize: '11pt',
              }}
              target="_blank"
            >
              To exercise the Right to Opt Out of Personal Information Sales or
              Sharing: email{' '}
            </a>
            <span
              style={{
                color: '#1154CC',
                fontFamily: 'Arial, sans-serif',
                fontStyle: 'normal',
                fontWeight: 'normal',
                textDecoration: 'underline',
                fontSize: '11pt',
              }}
            >
              privacy@zeme.io
            </span>{' '}
            <span style={{ color: '#000' }}>
              with sufficient information to identify you and your request.
            </span>
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <h1
            style={{
              paddingTop: '4pt',
              paddingLeft: '5pt',
              textIndent: '0pt',
              textAlign: 'left',
            }}
          >
            Submitting Authorized Agent Requests
          </h1>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            In certain circumstances, you are permitted by law to use an
            authorized agent to submit requests on your behalf through the
            designated methods set forth above where we can verify the
            authorized agent’s authority to act on your behalf. In order to
            verify the authorized agent’s authority, we generally require
            evidence of either: (i) a valid power of attorney; or (ii) a signed
            letter containing your name and contact information, the name and
            contact information of the authorized agent, and a statement of
            authorization for the request. Depending on the evidence provided
            and your state of residence, we may still need to separately reach
            out to you to confirm the authorized agent has permission to act on
            your behalf and to verify your identity in connection with the
            request.
          </p>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <h1
            style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left' }}
          >
            Appealing Privacy Rights Decisions
          </h1>
          <p style={{ textIndent: '0pt', textAlign: 'left' }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: '5pt',
              textIndent: '0pt',
              lineHeight: '114%',
              textAlign: 'left',
            }}
          >
            <a
              href="mailto:privacy@Zeme.io"
              style={{
                color: 'black',
                fontFamily: 'Arial, sans-serif',
                fontStyle: 'normal',
                fontWeight: 'normal',
                textDecoration: 'none',
                fontSize: '11pt',
              }}
              target="_blank"
            >
              Depending on your state of residence, you may be able to appeal a
              decision we have made in connection with your privacy rights
              request. All appeal requests should be submitted via email to{' '}
            </a>
            <a href="mailto:privacy@Zeme.io" target="_blank">
              privacy@zeme.io
            </a>
          </p>
        </main>
      </div>
    </>
  );
}

export default Privacy;
